export default "__VITE_ASSET__DmIxMIWK__"